<template>
    <div class="button-mob" @click="gotoApp">
        <img class="button-img" src="../assets/images/2025/button-img.png" alt="">
    </div>
 </template>
 
 <script>
 export default {
     name: 'MobButton',
     components: {
         
     },
     data () {
         return {
         
         }
     },
     mounted () {
     
     },
     methods: {
        gotoApp(){
            window.location.href = 'https://uat.kia.cn'
        }
     },
 }
 </script>
 <style>
 .button-mob {
    position: fixed;
    bottom: 65px;
    left: 10%;
    width: 80%;
    z-index: 999;
 }
 .button-img {
    width: 100%;
 }
 </style>